import { Action } from "../actions/types"
import { EmployeeType, EmployeeActionList } from "../actions/employeeActions"

const initialValue: Array<EmployeeType> = []

const employeeReducer = (state: Array<EmployeeType> = initialValue, action: Action) => {
    switch (action.type) {

        case EmployeeActionList.ADD_EMPLOYEE:
            return [
                ...state,
                action.data,
            ]

        case EmployeeActionList.UPDATE_EMPLOYEE:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case EmployeeActionList.FETCH_EMPLOYEE:
            return action.data

        case EmployeeActionList.DELETE_EMPLOYEE:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default employeeReducer